import React from 'react';
import { Settings, Bell, Shield, Users } from 'lucide-react';

export function TrainerSettings() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Settings</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Profile Settings */}
        <div className="theme-card p-6">
          <div className="flex items-center gap-3 mb-6">
            <Settings className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold">Profile Settings</h2>
          </div>
          {/* Profile settings content */}
        </div>

        {/* Notification Settings */}
        <div className="theme-card p-6">
          <div className="flex items-center gap-3 mb-6">
            <Bell className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold">Notifications</h2>
          </div>
          {/* Notification settings content */}
        </div>

        {/* Privacy Settings */}
        <div className="theme-card p-6">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold">Privacy</h2>
          </div>
          {/* Privacy settings content */}
        </div>

        {/* Client Settings */}
        <div className="theme-card p-6">
          <div className="flex items-center gap-3 mb-6">
            <Users className="w-5 h-5 text-primary" />
            <h2 className="text-lg font-semibold">Client Management</h2>
          </div>
          {/* Client settings content */}
        </div>
      </div>
    </div>
  );
}